import { render, staticRenderFns } from "./wind_sensor.vue?vue&type=template&id=19346394&"
import script from "./wind_sensor.vue?vue&type=script&lang=js&"
export * from "./wind_sensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports